import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function formValueMinLengthValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value.length >= minLength
      ? null
      : { lessThanMinLength: true };
  };
}
